export default "__VITE_ASSET__40578c70__"